import styles from './styles.module.scss';

const CancellationItem = ({ label, value, ...props }) => {
  return (
    <div className={styles.cancellationItem}>
      <input id={value} type="radio" value={value} {...props}></input>
      <label htmlFor={value}>{label}</label>
    </div>
  );
};
export default CancellationItem;
